import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { motion } from 'framer-motion';

export default function Home() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        type: 'spring',
        duration: 0.3,
        stiffness: 120,
        when: 'beforeChildren',
      }}
      className="header__section"
    >
      <h4>Welcome Ajay yadav</h4>
      <h1>Electronics</h1>
      <form className="input-form">
        <FiSearch />
        <input type="text" placeholder="Search Products" />
      </form>
    </motion.div>
  );
}
